import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setRestaurant } from "@/store/slicers/auth.slicer";
import { useEffect, useMemo } from "react";

const useRestaurant = () => {
  const { user, restaurant } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const restaurants = useMemo(() => {
    if (!user) return [];
    return user.restaurants || [];
  }, [user]);

  useEffect(() => {
    if (user && !restaurant && restaurants.length === 1) {
      dispatch(setRestaurant({ restaurant: restaurants[0] }));
    }
  }, [user, restaurants, restaurant]);

  return {
    restaurants,
    restaurant,
    restaurantId: restaurant?.id,
    setRestaurant: (restaurant: any) => dispatch(setRestaurant({ restaurant })),
  };
};

export default useRestaurant;
